<template>
    <div class="number-grow-warp">
        <span ref="numberGrow" :data-time="time" class="number-grow">0</span>
    </div>
    </template>
    
    <script>
    export default {
        props: {
            time: {
                type: Number,
                default: 1
            },
            value: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
    
            }
        },
        mounted() {
            this.numberGrow(this.$refs.numberGrow)
        },
        methods: {
            numberGrow(ele) {
                let step = parseInt((this.value) / (this.time * 100))
                let current = 0
                let start = 0
                let t = setInterval(() => {
                    start += step + 10
                    if (start >= this.value) {
                        clearInterval(t)
                        start = this.value
                        t = null
                    }
                    if (current === start) {
                        return
                    }
                    current = start
                    ele.innerHTML = current.toString().replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, '$1,')
                }, this.value == 200 ? 80 : 15)
            }
        },
    }
</script>

<style lang="less" scoped="scoped">
@media screen and (min-width: 769px) {
    .number-grow {
        font-family: Inter, syn;
        font-weight: 400;
        font-size: 68px;
        color: #0B243F;
        line-height: 68px;
        text-align: left;
        font-style: normal;
        display: flex;
        align-items: flex-end;
    }
}

@media screen and (max-width: 768px) {
}
</style>
    


// WEBPACK FOOTER //
// src/pages/home/components/NumberCounter.vue